import store from '../store'

export const analyticsDataLayer = {
  emit(event, extraData = {}) {

    dataLayer.push({ event, ...extraData });
  }
}